<template>
  <VBusHelper
    :reactOn="$constants.EVENTS.BOOKMAKER.REQUEST_BOOKMAKER_ID_CHANGE"
    :handler="() => $refs.modal.show()"
  />
  <VBusHelper
    :reactOn="$constants.EVENTS.BOOKMAKER.REQUEST_ACCOUNT_CONFIRMATION"
    :handler="() => $refs.modal.hide()"
  />
  <DialogComponent ref="modal" type="modal" mainClass="fixed z-[61]" noInnerPadding>
    <div class="bg-gradient-to-br from-secondary-50 to-white p-6">
      <!-- Header -->
      <div class="text-center mb-6">
        <div class="w-16 h-16 mx-auto mb-4 rounded-2xl flex items-center justify-center shadow-lg bg-secondary">
          <ImgComponent
            :src="
              $stores.bookmaker?.state?.bookmakerIdSetting?.bookmakerLogo
            "
            class="w-10 h-10"
            alt=""
          />
        </div>
        <h2 class="text-2xl font-bold text-gray-800 mb-1">
          Entrez votre ID
        </h2>
        <p class="text-gray-600">
          {{ $stores.bookmaker?.state?.bookmakerIdSetting.bookmakerName }}
        </p>
      </div>

      <!-- Screenshot Guide -->
      <div class="mb-6">
        <div class="flex items-center gap-2 mb-3">
          <ColorImg
            class="w-5 h-5 bg-secondary-100"
            src="/images/icons/idea.png"
            alt=""
          />
          <span class="text-sm font-semibold text-gray-700 uppercase tracking-wider">
            Guide visuel
          </span>
        </div>
        <ImgComponent
          :src="
            $stores.bookmaker?.state?.bookmakerIdSetting
              ?.bookmakerIdPageScreenshot
          "
          class="rounded-2xl shadow-lg border border-gray-200 w-full h-48 object-cover object-top"
          alt=""
        />
      </div>

      <!-- Form -->
      <form
        @submit.prevent="
          $bus.emit($constants.EVENTS.BOOKMAKER.REQUEST_ACCOUNT_CONFIRMATION, {
            bookmakerId:
              $stores.bookmaker?.state?.bookmakerIdSetting?.bookmakerId,
            bookmaker: $stores.bookmaker?.state?.bookmakerIdSetting?.bookmaker
          })
        "
      >
        <div class="mb-6">
          <label class="mb-2 px-1 text-xs font-bold text-gray-400 uppercase tracking-wider block">
            Votre ID {{ $stores.bookmaker?.state?.bookmakerIdSetting.bookmakerName }}
          </label>
          <input
            v-model="$stores.bookmaker.state.bookmakerIdSetting.bookmakerId"
            type="text"
            required
            class="w-full px-5 py-4 text-lg font-semibold rounded-2xl border-2 border-gray-200 focus:border-secondary-400 focus:ring-4 focus:ring-secondary-100 outline-none transition-all"
            placeholder="Ex: 61020304"
          />
        </div>

        <!-- Buttons -->
        <div class="flex flex-col gap-3">
          <button
            type="submit"
            class="w-full py-4 px-6 text-white font-bold text-lg rounded-2xl shadow-xl hover:shadow-2xl transition-all duration-300 transform hover:scale-[1.02] active:scale-[0.98] relative overflow-hidden group bg-secondary"
          >
            <span class="relative z-10 flex items-center justify-center gap-2">
              Utiliser cet ID
              <svg class="w-5 h-5 group-hover:translate-x-1 transition-transform" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M14 5l7 7m0 0l-7 7m7-7H3"></path>
              </svg>
            </span>
          </button>
          <button
            type="button"
            class="w-full py-4 px-6 font-semibold rounded-2xl border-2 transition-all duration-300 flex items-center justify-center gap-3 hover:bg-gray-50 active:scale-[0.98] border-gray-300 text-gray-600"
            @click="() => $refs.modal.hide()"
          >
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
              <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M10 19l-7-7m0 0l7-7m-7 7h18"></path>
            </svg>
            Retour
          </button>
        </div>
      </form>
    </div>
  </DialogComponent>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  name: 'BookmakerAccountSetter'
});
</script>
